<template>
  <div class="page-404">
    <div class="page-404-content" > 404 </div>
    <div class="page-404-content"> page not found </div>
    
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped >
  .page-404{
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    background-color: #2B304D;
    .page-404-content{
      color: #ffffff;
      font-size: 3rem;

    }
  }
</style>